export const currencyData: {
  id: number;
  name: string;
  display_name: string;
}[] = [
  { id: 1, name: '$', display_name: '$' },
  { id: 2, name: '€', display_name: '€' },
  { id: 3, name: '₽', display_name: '₽' },
  { id: 4, name: '₸', display_name: '₸' },
  { id: 5, name: 'AED', display_name: 'AED' },
];
